import { render } from "./MarcketResearch.vue?vue&type=template&id=37724c3c"
import script from "./MarcketResearch.vue?vue&type=script&lang=js"
export * from "./MarcketResearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__